import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-book-open-line text-xl"></i>
              </span>
              <span className="font-heading text-2xl text-background-50">韩漫星球</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-background-200">
              韩漫星球汇聚海量韩国漫画，覆盖爱情、奇幻、动作、校园、悬疑等全部分类。高清画质、每日更新，为你打造畅快的追漫体验，找到每一部值得一看的佳作。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['高清畅读', '每日更新', '分类齐全', '正版精选'].map((t) => (
                <span
                  key={t}
                  className="inline-flex items-center gap-1 rounded-full bg-background-800 px-3 py-1 text-xs text-background-200"
                >
                  <i className="ri-checkbox-circle-line text-accent-400"></i> {t}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50">漫画分类</h4>
            <ul className="mt-4 space-y-2 text-sm">
              {categories.map((c) => (
                <li key={c.key}>
                  <Link to={`/category?cat=${c.key}`} className="text-background-200 hover:text-accent-400 transition-colors">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50">快速导航</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/" className="text-background-200 hover:text-accent-400 transition-colors">网站首页</Link></li>
              <li><Link to="/category" className="text-background-200 hover:text-accent-400 transition-colors">全部漫画</Link></li>
              <li><Link to="/about" className="text-background-200 hover:text-accent-400 transition-colors">关于我们</Link></li>
              <li><Link to="/faq" className="text-background-200 hover:text-accent-400 transition-colors">常见问题</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 items-center justify-between border-t border-background-800 pt-6 sm:flex-row">
          <p className="text-xs text-background-300">
            © {new Date().getFullYear()} 韩漫星球 Hancomic · 海量韩国漫画在线畅读
          </p>
          <p className="text-xs text-background-300">
            联系方式：service@hancomic.example
          </p>
        </div>
      </div>
    </footer>
  );
}